import * as React from 'react';
import Page from 'components/Page';
import { connect } from 'react-redux';
import * as loginSelectors from 'store/login/reducer';

import { Button, Row, Col, Input, Label, FormGroup} from 'reactstrap';

// import { Bar, Doughnut, } from 'react-chartjs-2';

import BaseService from '../services/BaseService';

import bgimage from '../assets/img/icon/ms-excel.png';
import ReactExport from "react-data-export";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class ReportTax extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isloaded: false,
            date_from: this.returnDate("today"),
            date_to: this.returnDate("today"),
            reportData: [],
            reportTotal: [],
            reportGroup: []
        };
    
        this.handleInputChange = this.handleInputChange.bind(this);     
        this.onPlaque = this.onPlaque.bind(this);  
    }

    onPlaque() { 
        this.componentDidMount(); }

    returnDate(type) {var da = new Date();
        var year = da.getFullYear();
        var month = da.getMonth() + 1;
        var day = da.getDate();
        // var data = new Date(year, month, 0);

        if (da.getMonth() + 1 < 10) {
            month = "0" + (da.getMonth() + 1);}

        if (type === "to") {
            return year + "-" + month + "-" + day;
        } else if (type === "today") {
            return year + "-" + month + "-" + day;
        } else { 
            day = "01"; return year + "-" + month + "-" + day;}
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({[name]: value});
    }     

    renderAPI = () => {

        var date1 = this.state.date_from;
        var date2 = this.state.date_to;
        date1 = date1.replace("/", "-").replace("/", "-");
        date2 = date2.replace("/", "-").replace("/", "-");

        fetch(BaseService.ENDPOINT + "admin/statistics/report-tax?ini_date=" + date1 + "&end_date=" + date2, {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                Authorization: 'Bearer ' + this.props.user.access_token
            })
        })
        .then(res => res.json())
        .then(res => { 
            this.setState({
                reportData: res.data.results,
                reportTotal: res.data.total,
                reportGroup: res.data.group,
                isloaded: true  
            })
        })   

        // console.log(BaseService.ENDPOINT + "admin/statistics/report-tax?ini_date=" + date1 + "&end_date=" + date2)
        // console.log(this.props.user.access_token)
    }  

    componentDidMount(){    
        this.renderAPI()
    }

    renderListHeader() {
        if (this.state.isloaded){
            return(
                <thead>
                <tr>
                    <th>Id Reporte</th>
                    <th>Placa</th>
                    <th>Endereço</th>
                    <th>Vaga</th>
                    <th>Cód. Reporte</th>
                    <th>Responsável</th>
                    <th>Data Pagamento</th>
                    <th>Valor Pago</th>
                </tr>
                </thead>
            )
        }
    }
    
    renderListBody() {
        if (this.state.isloaded){

            const numberFormat = (value) => new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(value);

            return this.state.reportData.map((ret)=>{return(
                <tr key={ret.id}>
                    <td>{ret.id}</td>
                    <td>{ret.placa}</td>
                    <td>{ret.endereco}</td>
                    <td>{ret.vaga}</td>
                    <td>{ret.reporte}</td>
                    <td>{ret.responsavel}</td>
                    <td>{ret.datapagamento}</td>
                    <td align='right'>{numberFormat(ret.valorpago)}</td>
                </tr>
            )})

        } else { return <span><strong>Carregando...</strong></span> }
     }    

     renderListFooter() {
        if (this.state.isloaded){

            const numberFormat = (value) => new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(value);

            return(
                <tfoot>
                <tr>
                    <td></td>
                    <td></td>
                    <td><strong>Total</strong></td>
                    <td align='right'><strong>{numberFormat(this.state.reportTotal[0].Total)}</strong></td>
                </tr>
                </tfoot>
            )
        }         
     }

   

     getResults() {
        var dat = [];
        for(var i=0; i<this.state.reportData.length; i++){
            dat.push(
                [
                    { value: this.state.reportData[i].id },
                    { value: this.state.reportData[i].placa },
                    { value: this.state.reportData[i].endereco },
                    { value: this.state.reportData[i].vaga },
                    { value: this.state.reportData[i].reporte },
                    { value: this.state.reportData[i].responsavel },
                    { value: this.state.reportData[i].datapagamento },
                    { value: this.state.reportData[i].valorpago }            
                ]
            )
        }
        const multidataSet = [
            {
                columns: [
                    {   title: "Id", width: {wch: 20} },
                    {   title: "Placa", width: {wch: 20}},
                    {   title: "Endereço", width: {wch: 20}},                    
                    {   title: "Vaga", width: {wch: 15}},
                    {   title: "Reporte", width: {wch: 15}},
                    {   title: "Responsável", width: {wch: 15}},
                    {   title: "Data Pagamento", width: {wch: 15}},
                    {   title: "Valor Pago", width: {wch: 15}}
                ],
                    data: dat,
            }
        ]
        return multidataSet
    }        
    
    render() {
        return (
            <Page
                title="Histórico de Pagamento de Irregularidades"
                className="ReportTax"
                style={{
                    minHeight: '84vh'
                }}>
                <style>{"\
                    table {\
                        background: #FFFFFF;\
                        width: 100%;\
                    }\
                    tr {\
                        border: 1px solid #C9C9C9;\
                    }\
                    th {\
                        // background: green;\
                        // color: #FFFFFF;\
                        font-weight: bold;\
                        border-bottom: 2px solid #C9C9C9;\
                        padding: 15px;\
                    }\
                    td {\
                        max-width: 400px;\
                        overflow: hidden;\
                        text-overflow: ellipsis;\
                        white-space: nowrap;\
                        padding: 10px;\
                    }\
                    tfoot{\
                        font-weight: bold !important;\
                        border-top: 2px solid #C9C9C9;\
                        border-bottom: 2px solid #C9C9C9;\
                        padding: 15px;\
                    }\
                "}</style>

                <Row>

                    <Col sm={3} >
                        <FormGroup>
                            <Label >De: </Label>
                            <Input
                                type="date"
                                maxLength={10}
                                name="date_from"
                                value={this.state.date_from}
                                onChange={this.handleInputChange}
                                invalid={this.state.dateFrom}
                                max={this.state.date_to}
                            ></Input>
                        </FormGroup>
                    </Col>
                    <Col sm={3}   >
                        <FormGroup>
                            <Label>Até: </Label>
                            <Input
                                type="date"
                                maxLength={10}
                                name="date_to"
                                value={this.state.date_to}
                                onChange={this.handleInputChange}
                                invalid={this.state.dateTo}
                                min={this.state.date_from}
                            ></Input>
                        </FormGroup>
                    </Col>
                    <Col sm={3}>
                        <br />
                        <Button
                            outline
                            onClick={this.onPlaque}
                            style={{
                                marginTop: '7px'
                            }}
                        > Procurar</Button>
                    </Col>

                    <Col sm={3}>
                        <br />
                        <ExcelFile 
                            element={
                                <Button 
                                    outline
                                    style={{
                                        marginTop: '7px'
                                    }}
                                    >
                                    <img src={bgimage} alt="excel" />Exportar para Excel</Button>}>
                                <ExcelSheet dataSet={this.getResults()} name="RelatorioCreditoLojista">
                            </ExcelSheet>
                        </ExcelFile>
                    </Col>

                </Row>

                <Row>
                <FormGroup style={{ marginLeft: 15, width: '95%'}}>

                    <Row>
                        <Col sm={12} md={12} lg={12}>
                            <small>
                            <table id='repotList'>
                                {this.renderListHeader()}
                                <tbody>{this.renderListBody()}</tbody>
                                {this.renderListFooter()}
                            </table>
                            </small>
                        </Col>
                    </Row>

                </FormGroup>
                </Row>

            </Page>
        );
    }
};


// which props do we want to inject, given the global store state?
function mapStateToProps(state) {
    const currentUser = loginSelectors.getUser(state);
    return {
        user: currentUser
    };
}
export default connect(mapStateToProps)(ReportTax)


// WEBPACK FOOTER //
// ./src/pages/ReportTax.js